import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const allowanceDataForm: Form<Client> = {
  key: 'allowanceData',
  title: 'Zuschüsse',
  fields: [
    {
      key: 'parentalAllowance',
      fieldTypes: 'headline',
      label: 'Elterngeld',
      xsWidth: 8,
    },
    {
      key: 'parentalAllowanceRequested',
      label: 'beantragt',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'parentalAllowanceFrom',
      label: 'bewilligt von',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'parentalAllowanceTill',
      label: 'bewilligt bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'parentalAllowanceAmount',
      label: 'Höhe',
      fieldTypes: 'number',
      xsWidth: 4,
    },
    {
      key: 'childAllowance',
      fieldTypes: 'headline',
      label: 'Kindergeld',
      xsWidth: 8,
    },
    {
      key: 'childAllowanceRequested',
      label: 'beantragt',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'childAllowanceFrom',
      label: 'bewilligt von',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'childAllowanceTill',
      label: 'bewilligt bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'childAllowanceAmount',
      label: 'Höhe',
      fieldTypes: 'number',
      xsWidth: 4,
    },
    {
      key: 'familyAllowance',
      fieldTypes: 'headline',
      label: 'Familiengeld',
      xsWidth: 8,
    },
    {
      key: 'familyAllowanceRequested',
      label: 'beantragt',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'familyAllowanceFrom',
      label: 'bewilligt von',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'familyAllowanceTill',
      label: 'bewilligt bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'familyAllowanceAmount',
      label: 'Höhe',
      fieldTypes: 'number',
      xsWidth: 4,
    },
    {
      key: 'uvg',
      fieldTypes: 'headline',
      label: 'UVG',
      xsWidth: 8,
    },
    {
      key: 'uvgRequested',
      label: 'beantragt',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'uvgFrom',
      label: 'bewilligt von',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'uvgTill',
      label: 'bewilligt bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'uvgAmount',
      label: 'Höhe',
      fieldTypes: 'number',
      xsWidth: 4,
    },
    {
      key: 'supplementaryChildAllowance',
      fieldTypes: 'headline',
      label: 'Kindergeldzuschlag',
      xsWidth: 8,
    },
    {
      key: 'supplementaryChildAllowanceRequested',
      label: 'beantragt',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'supplementaryChildAllowanceFrom',
      label: 'bewilligt von',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'supplementaryChildAllowanceTill',
      label: 'bewilligt bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'supplementaryChildAllowanceAmount',
      label: 'Höhe',
      fieldTypes: 'number',
      xsWidth: 4,
    },
    {
      key: 'accommodationAllowance',
      fieldTypes: 'headline',
      label: 'Wohngeld',
      xsWidth: 8,
    },
    {
      key: 'accommodationAllowanceRequested',
      label: 'beantragt',
      fieldTypes: 'checkbox',
      xsWidth: 4,
    },
    {
      key: 'accommodationAllowanceFrom',
      label: 'bewilligt von',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'accommodationAllowanceTill',
      label: 'bewilligt bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'accommodationAllowanceAmount',
      label: 'Höhe',
      fieldTypes: 'number',
      xsWidth: 4,
    },
    {
      key: 'furtherAllowances',
      label: 'Weitere Zuschüsse',
      fieldTypes: 'select',
      options: [],
      xsWidth: 12,
    },
  ],
};

export default allowanceDataForm;
